// extracted by mini-css-extract-plugin
export default {"referral__main":"Referral_referral__main__VWXDT","referral__title":"Referral_referral__title__6nRW2","referral__info":"Referral_referral__info__TDrNw"};